import { COLORS } from '@/config/colors';
import {
  alpha,
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

export const textfield: {
  defaultProps?: ComponentsProps['MuiTextField'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTextField'];
  variants?: ComponentsVariants<Theme>['MuiTextField'];
} = {
  defaultProps: {
    size: 'medium',
    InputLabelProps: { shrink: true },
  },
  variants: [
    {
      // Taille commune aux champs valides et en erreur : réservée aux seuls
      // champs valides, elle faisait passer un champ en erreur à la hauteur
      // par défaut de MUI (28 → 52 px) dès la première lettre tapée.
      props: { color: 'primary', variant: 'outlined' },
      style({ theme }) {
        return {
          '& .MuiOutlinedInput-root': {
            borderRadius: '4px',
            minHeight: 28,
            fontSize: 12,
            boxShadow: 'none',
            '& input': {
              padding: '5px 10px',
              color: '#fafafa',
              '&::placeholder': {
                color: '#404040',
                opacity: 1,
              },
            },
            '& textarea': {
              color: '#fafafa',
              '&::placeholder': {
                color: '#404040',
                opacity: 1,
              },
            },
            // iOS agrandit la page dès qu'un champ passe sous 16px, et ne la
            // réduit jamais tout seul : l'utilisateur reste coincé dans une
            // vue zoomée après avoir tapé un caractère. 16px est la seule
            // valeur qui l'en empêche.
            [theme.breakpoints.down('md')]: {
              minHeight: 40,
              fontSize: 16,
              '& input': {
                padding: '8px 12px',
              },
            },
          },
        };
      },
    },
    {
      props: { error: false, color: 'primary', variant: 'outlined' },
      style({ theme }) {
        return {
          input: {
            fontWeight: 'normal',
            '&:placeholder': {
              color: 'red',
            },
          },
          '& label': {
            color: theme.palette.grey[500],
          },
          '&:hover label': {
            color: theme.palette.grey[400],
          },
          '& label.Mui-focused': {
            color: theme.palette.grey[300],
          },
          '& .MuiOutlinedInput-root': {
            background: '#050507',
            '& fieldset': {
              borderColor: 'rgba(255,255,255,0.06)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(255,255,255,0.10)',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'rgba(41,61,237,0.6)',
              borderWidth: 1,
            },
            '&.Mui-disabled fieldset': {
              borderColor: 'transparent',
              cursor: 'not-allowed',
            },
            '&.Mui-disabled': {
              opacity: 0.7,
            },
          },
        };
      },
    },
    {
      props: { error: true, color: 'primary', variant: 'outlined' },
      style() {
        return {
          '& label': {
            color: COLORS.error[500],
          },
          '&:hover label': {
            color: COLORS.error[400],
          },
          '& label.Mui-focused': {
            color: COLORS.error[500],
          },
          '& .MuiOutlinedInput-root': {
            background: alpha('#ffffff', 0.05),
            '& fieldset': {
              borderColor: COLORS.error[500],
            },
            '&:hover fieldset': {
              borderColor: COLORS.error[600],
            },
            '&.Mui-focused fieldset': {
              borderColor: COLORS.error[500],
            },
          },
        };
      },
    },
  ],
  styleOverrides: {
    root({ theme }) {
      return {
        '.MuiOutlinedInput-notchedOutline': {
          transition: `${theme.transitions.duration.shortest}ms`,
        },
      };
    },
  },
};
